import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { sortBy, tryFind } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { defaultOf, comparePrimitives, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Company_fetchCompanies } from "../Promises.js";
import { defaultArg, some } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TextField, Autocomplete } from "@mui/material";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";

export function CompanySelect(companySelectInputProps) {
    const required = companySelectInputProps.required;
    const onChange = companySelectInputProps.onChange;
    const selectedOpt = companySelectInputProps.selectedOpt;
    const label = companySelectInputProps.label;
    const patternInput = reactApi.useState([]);
    const companies = patternInput[0];
    const companyOpt = tryFind((company) => equals(company.Id, selectedOpt), companies);
    reactApi.useEffect(() => {
        const pr = Company_fetchCompanies();
        pr.then((res) => {
            if (res.tag === 0) {
                patternInput[1](sortBy((_arg) => _arg.Name, res.fields[0], {
                    Compare: comparePrimitives,
                }));
            }
            else {
                console.error(some("Error fetching companies"), res.fields[0]);
            }
        });
    }, []);
    return MuiHelpers_createElement(Autocomplete, [["size", "small"], ["multiple", false], ["getOptionLabel", (company_1) => company_1.Name], ["value", defaultArg(companyOpt, defaultOf())], ["options", Array.from(companies)], ["onChange", (delegateArg, delegateArg_1, delegateArg_2) => {
        onChange(delegateArg_1);
    }], ["renderInput", (p) => MuiHelpers_createElement(TextField, toList(delay(() => append(Object.entries(p), delay(() => append(singleton(["required", required]), delay(() => singleton(["label", label]))))))))]]);
}

